import Header from "../components/Header";
import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { withAuthConsumer } from "../authcontext/AuthConsumer";

const SignedOutHOC = (WrappedComponent) => {
  const SignedOutHOC = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const { t, i18n } = useTranslation();

    // Create history object for backwards compatibility with class components
    const history = {
      push: (path, state) => navigate(path, { state }),
      replace: (path, state) => navigate(path, { replace: true, state }),
      location
    };

    return (
      <>
        <Header />
        <main className="mainContent">
          <WrappedComponent {...props} t={t} i18n={i18n} history={history} location={location} match={{ params }} />
        </main>
      </>
    );
  };

  return withAuthConsumer(SignedOutHOC);
};

export default SignedOutHOC;
